import axios from 'axios'

// 供应商快递账号列表(分页)
export function getSupplierList(data) {
  return axios({
    url: `/api/ums/supplierExpressAccount/listPage`,
    method: 'get',
    params: data
  })
}
// 供应商快递账号列表(不分页)
export function getSupplierAll(data) {
  return axios({
    url: `/api/ums/supplierExpressAccount/list`,
    method: 'get',
    params: data
  })
}
// 供应商快递账号(新增)
export function insertSupplier(data) {
  return axios({
    url: `/api/ums/supplierExpressAccount/insert`,
    method: 'post',
    data
  })
}
// 供应商快递账号(修改)
export function updateSupplier(data) {
  return axios({
    url: `/api/ums/supplierExpressAccount/update`,
    method: 'post',
    data
  })
}
// 供应商快递账号(删除)
export function deleteSupplier(id) {
  return axios({
    url: `/api/ums/supplierExpressAccount/delete?id=${id}`,
    method: 'get'
  })
}

// 供应商公司列表(分页)
export function getSupplierCompany(data) {
  return axios({
    url: `/api/pms/supplier/listPage`,
    method: 'get',
    params: data
  })
}
// 供应商公司通过ID查询
export function getSupplierCompanyId(id) {
  return axios({
    url: `/api/pms/supplier/get/${id}`,
    method: 'get'
  })
}
// 供应商公司新增
export function insertSupplierCompany(data) {
  return axios({
    url: `/api/pms/supplier/inset`,
    method: 'post',
    data
  })
}
// 供应商公司修改
export function updateSupplierCompany(data) {
  return axios({
    url: `/api/pms/supplier/update`,
    method: 'post',
    data
  })
}
// 供应商公司删除
export function deleteSupplierCompany(id) {
  return axios({
    url: `/api/pms/supplier/delete/${id}`,
    method: 'get'
  })
}

// 预约取件，适用于不需要打印快递面单的供应商
export function appointmentPic(data) {
  return axios({
    url: `/api/express/thirdExpress/appointmentPickup`,
    method: 'post',
    data
  })
}
// 预约取消
export function appointmentCan(data) {
  return axios({
    url: `/api/express/thirdExpress/appointmentCancel`,
    method: 'post',
    data
  })
}

// 电子面单寄件、用于需要打印面单
export function electronicPic(data) {
  return axios({
    url: `/api/express/thirdExpress/electronicPickup`,
    method: 'post',
    data
  })
}

// 电子面单取消
export function electronicCan(data) {
  return axios({
    url: `/api/express/thirdExpress/electronicCancel`,
    method: 'post',
    data
  })
}

// 查询快递物流信息
export function getThirdExpress(mailNo) {
  return axios({
    url: `/api/express/thirdExpress/query?mailNo=${mailNo}`,
    method: 'get'
  })
}

// 手动填写快递单号
export function manuaFillExpress(data) {
  return axios({
    url: `/api/express/thirdExpress/manualFillExpressNo`,
    method: 'post',
    data
  })
}

// 供应商发货子订单列表(分页)
export function getOrderItemSup(data) {
  return axios({
    url: `/api/oms/orderSmallItem/listPage`,
    method: 'get',
    params: data
  })
}

// 供应商发货子订单列表(不分页)
export function getOrderItemSupAll(data) {
  return axios({
    url: `/api/oms/orderSmallItem/list`,
    method: 'get',
    params: data
  })
}
// 供应商发货子订单修改
export function updateOrderItemSup(data) {
  return axios({
    url: `/api/oms/orderSmallItem/update`,
    method: 'post',
    data
  })
}

// 批量修改子订单状态
export function updateBatchOrderItem(data) {
  return axios({
    url: `/api/oms/orderSmallItem/batchUpdate`,
    method: 'post',
    data
  })
}

// 通过快递单号查询记录补打电子面单
export function getByExpressNo(expressNo) {
  return axios({
    url: `/api/pms/pmsSmallExpress/getByExpressNo?expressNo=${expressNo}`,
    method: 'get'
  })
}

// 小商品订单补发
export function createReship(data) {
  return axios({
    url: `/api/express/thirdExpress/reship/create`,
    method: 'post',
    data
  })
}

// 查询小商品订单补发历史
export function getReshipList(orderSn) {
  return axios({
    url: `/api/express/thirdExpress/reship/list?orderSn=${orderSn}`,
    method: 'get'
  })
}
